import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect в SSR/пререндере пишет предупреждение в консоль.
 * Лендинг может собираться статически, поэтому переключатель нужен.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
